import { services } from "@/mocks/services";
import { ScrollReveal } from "@/components/base/ScrollReveal";

export default function Services() {
  return (
    <section id="services" role="region" aria-label="事業内容" className="relative bg-background-100/60 py-20 md:py-32 px-6 md:px-16 lg:px-24">
      <div className="max-w-7xl mx-auto">
        {/* Section header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12 md:mb-16">
          <div>
            <div className="inline-flex items-center gap-3 mb-4">
              <span className="w-10 h-px bg-primary-500"></span>
              <span className="text-xs tracking-[0.3em] uppercase text-primary-700 font-medium">
                Our Services
              </span>
            </div>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
              住まいに関わる、<br />
              すべてを一手に。
            </h2>
          </div>
          <p className="max-w-md text-foreground-700 text-sm md:text-base leading-relaxed">
            原状回復から大規模リノベーションまで。建物に関わるあらゆる工事を、
            Wind が責任を持って対応します。お気軽にご相談ください。
          </p>
        </div>

        {/* Service grid */}
        <ScrollReveal direction="up" stagger threshold={0.03} rootMargin="0px 0px -10px 0px">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" role="list" aria-label="サービス一覧">
            {services.map((s, idx) => (
              <div key={s.id} role="listitem" className="group relative overflow-hidden rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-500 cursor-pointer">
                <a
                  rel="noopener noreferrer"
                  target="_blank"
                  href={s.link}
                  className="block"
                  aria-label={`${s.title}の詳細を見る`}
                >
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img
                    src={s.image}
                    alt={s.title}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/10 to-transparent"></div>
                  <div className="absolute top-4 left-4 flex items-center gap-2">
                    <span className="px-3 py-1 rounded-full bg-background-50/90 backdrop-blur-sm text-[10px] tracking-[0.2em] font-bold text-foreground-900">
                      {s.no}
                    </span>
                    {idx === 0 && (
                      <span className="px-3 py-1 rounded-full bg-accent-500 text-background-50 dark:text-foreground-950 text-[10px] tracking-wider font-bold">
                        人気
                      </span>
                    )}
                  </div>
                  <div className="absolute bottom-4 left-4 right-4 flex items-end justify-between">
                    <div>
                      <p className="text-[10px] text-background-50/80 tracking-[0.25em] uppercase mb-1">
                        {s.en}
                      </p>
                      <h3 className="text-background-50 text-xl md:text-2xl font-heading font-bold">
                        {s.title}
                      </h3>
                    </div>
                    <span className="w-10 h-10 rounded-full bg-background-50/90 backdrop-blur-md flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                      <i className={`${s.icon} text-foreground-900 group-hover:text-background-50 transition-colors`}></i>
                    </span>
                  </div>
                </div>
                </a>
                <a
                  rel="noopener noreferrer"
                  target="_blank"
                  href={s.link}
                  className="block p-5 md:p-6"
                  aria-label={`${s.title}の詳細を見る`}
                >
                <div className="flex items-center justify-between gap-4">
                  <p className="text-sm text-foreground-700 leading-relaxed">{s.desc}</p>
                  <span className="w-9 h-9 rounded-full border border-background-300 flex items-center justify-center shrink-0 group-hover:border-primary-500 group-hover:bg-primary-500 transition-colors">
                    <i className="ri-arrow-right-up-line text-foreground-700 group-hover:text-background-50 transition-colors"></i>
                  </span>
                </div>
                </a>
              </div>
            ))}
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}